import React, { useState } from 'react';
import { EyeIcon, EyeSlashIcon } from 'components/icons';

type PasswordInputProps = React.InputHTMLAttributes<HTMLInputElement>;

/**
 * Password field with a reveal toggle. Works standalone as a controlled input
 * and inside Formik via <Field as={PasswordInput} />, which passes the field
 * props straight through.
 */
const PasswordInput: React.FC<PasswordInputProps> = ({ className = 'input', ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        className={`${className} pr-11`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-content-muted hover:text-content focus:outline-none focus:ring-2 focus:ring-brand-500 rounded-r-md"
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        title={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? (
          <EyeSlashIcon className="h-5 w-5" aria-hidden="true" />
        ) : (
          <EyeIcon className="h-5 w-5" aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

export default PasswordInput;
